<template>
    <!-- Sin logo, las iniciales en un círculo: nunca un <img> con src «…/null» (H40). Tampoco
    el texto alternativo cuando el archivo no carga (borrado, o una copia de la base sin su media). -->
    <img v-if="src && !failed" :src="src" :alt="alt" :class="imgClass" @error="failed = true" />
    <span v-else :class="['activity-initials', { 'activity-initials--fill': fill }, initialsClass]"
          :style="fill ? null : { width: size + 'px', height: size + 'px', fontSize: Math.round(size * 0.42) + 'px' }"
          :title="activity && activity.name" role="img" :aria-label="alt || (activity && activity.name) || ''">
        {{ initials }}
    </span>
</template>

<script>
import { activityLogoSrc, activityInitials } from '../../models/econActivity';

export default {
    name: 'ActivityLogo',
    props: {
        activity: { type: Object, default: null },
        alt: { type: String, default: '' },
        imgClass: { type: [String, Array, Object], default: '' },
        initialsClass: { type: [String, Array, Object], default: '' },
        size: { type: Number, default: 32 },
        // Ocupa todo el contenedor (el botón redondo del topbar móvil).
        fill: { type: Boolean, default: false },
    },
    data() {
        return { failed: false };
    },
    watch: {
        // Otro logo: otra oportunidad de cargar.
        src() {
            this.failed = false;
        },
    },
    computed: {
        src() {
            return activityLogoSrc(this.activity, this.$baseURL);
        },
        initials() {
            return activityInitials(this.activity);
        },
    },
};
</script>

<style scoped>
.activity-initials {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 50%;
    background: var(--primary-color);
    color: var(--primary-color-text);
    font-weight: 700;
    letter-spacing: 0.02em;
    line-height: 1;
    user-select: none;
}
.activity-initials--fill {
    width: 100%;
    height: 100%;
    font-size: 0.85rem;
}
</style>
